export const ROUTE_PATH = {
  ALL: '*',
  LOGIN: '/login',

  HOME: '/',
  POINT: 'point',
  USER: '/user',
  USER_MANAGEMENT: '/user-management',
  ID: 'id',
  BROWSER: 'browser',
};
